import { ArrowsLeftRight, ChatCircle, Phone, VideoCamera } from "@phosphor-icons/react"
import { CommunicationChannel } from "@/types/__generated__/union-types"

export const getProgressNoteChannel = (channel: CommunicationChannel) => {
  switch (channel) {
    case "CHAT":
      return <ChatCircle className="text-on-surface-subdued size-3" />
    case "PHONE":
      return <Phone className="text-on-surface-subdued size-3" />
    case "ASYNC_REQUEST":
      return <ArrowsLeftRight className="text-on-surface-subdued size-3" />
    case "VIDEO":
      return <VideoCamera className="text-on-surface-subdued size-3" />
  }
}
